"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePreviousLocation = exports.usePrevious = exports.useLocationChange = void 0;
var _react = require("react");
var _reactRouter = require("react-router");
var usePrevious = exports.usePrevious = function usePrevious(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
};
var useLocationChange = exports.useLocationChange = function useLocationChange(notifier) {
  var history = (0, _reactRouter.useHistory)();
  var location = (0, _reactRouter.useLocation)();
  var prevLocation = usePrevious(location);
  (0, _react.useEffect)(function () {
    notifier(location, history.action, prevLocation);
  }, [history, location, prevLocation, notifier]);
};
var usePreviousLocation = exports.usePreviousLocation = function usePreviousLocation() {
  var history = (0, _reactRouter.useHistory)();
  var route = (0, _react.useRef)();
  var enabled = (0, _react.useRef)(false);
  var counter = (0, _react.useRef)(0);
  var notifier = (0, _react.useCallback)(function (current, action, previous) {
    if (!enabled.current) return;
    if (!previous) {
      counter.current = 0;
      return;
    }
    if (current.pathname !== previous.pathname) {
      route.current = previous;
      counter.current = 0;
    } else if (action === 'PUSH') {
      counter.current = counter.current + 1;
    } else if (action === 'POP') {
      counter.current = counter.current - 1;
    }
  }, []);
  var goBack = (0, _react.useCallback)(function () {
    // if (counter.current > 0) {
    //     history.go((counter.current + 1) * -1)
    // }
    if (route.current) {
      history.push(route.current.pathname);
    } else {
      history.goBack();
    }
  }, [history]);
  var enable = (0, _react.useCallback)(function () {
    enabled.current = true;
    counter.current = 0;
    route.current = undefined;
  }, []);
  var getRoute = (0, _react.useCallback)(function () {
    var _a, _b;
    return (_b = (_a = route.current) === null || _a === void 0 ? void 0 : _a.pathname) !== null && _b !== void 0 ? _b : '-';
  }, []);
  var instance = (0, _react.useMemo)(function () {
    return {
      getRoute: getRoute,
      goBack: goBack,
      enable: enable
    };
  }, [getRoute, goBack, enable]);
  useLocationChange(notifier);
  return instance;
};